import React from "react";
import "./Support.scss";

const Support: React.FC = () => {
  return (
    <main id="support" className="support">
      <h1>Support</h1>
      <p className="support-tagline">
        We're here to help. Reach out and we'll get back to you as quickly as
        possible.
      </p>

      <h2>Contact Support</h2>
      <p>
        Email us at <a href="mailto:support@mindara.io">support@mindara.io</a> —
        we typically respond within one business day.
      </p>

      <h2>Common Questions</h2>

      <h3>Getting started</h3>
      <p>
        <strong>How do I create a plan?</strong>
        <br />
        Open the Mindara app, tap the Create tab, and describe what kind of
        night out you're looking for. The AI will suggest venues, you can add up
        to 3 activities, then invite your friends.
      </p>
      <p>
        <strong>How do I invite friends?</strong>
        <br />
        From any plan, tap "Invite" and select contacts. They'll receive a
        notification and can RSVP directly in the app.
      </p>
      <p>
        <strong>How do I make a Resy reservation?</strong>
        <br />
        When adding a restaurant to your plan, tap "Reserve" to see available
        Resy booking times. Complete the reservation without leaving Mindara.
      </p>

      <h3>Account and subscriptions</h3>
      <p>
        <strong>How do I manage my Mindara Premium subscription?</strong>
        <br />
        iOS subscriptions are billed and managed by Apple. To view, change, or
        cancel your subscription, go to your iPhone Settings → [your name] →
        Subscriptions → Mindara. For billing disputes or refund requests, please
        contact{" "}
        <a
          href="https://reportaproblem.apple.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Apple Support
        </a>{" "}
        directly — Apple processes all iOS subscription payments.
      </p>
      <p>
        <strong>How do I delete my account?</strong>
        <br />
        In the Mindara app, go to Settings → Account → Delete Account. Deletion
        is permanent and removes all your plans, data, and account information
        within 30 days. This action cannot be undone.
      </p>
      <p>
        <strong>I forgot my sign-in method — how do I log in?</strong>
        <br />
        Mindara uses Sign in with Apple or Sign in with Google (no separate
        password). Use the same Apple ID or Google account you used when you
        first signed up. If you signed up with Apple and chose to hide your
        email, use the same "Hide My Email" relay address.
      </p>

      <h3>Technical issues</h3>
      <p>
        <strong>The app isn't loading / showing an error</strong>
        <br />
        Try closing and reopening the app. If the issue persists, check your
        internet connection and ensure you're running the latest version from
        the App Store. Contact us at support@mindara.io if problems continue.
      </p>
      <p>
        <strong>Location or contacts aren't working</strong>
        <br />
        Go to iPhone Settings → Mindara and confirm that Location and Contacts
        permissions are enabled. Mindara needs "While Using the App" location
        access to show nearby venues.
      </p>

      <p className="last-updated">
        Mindara · <a href="/privacy">Privacy Policy</a> ·{" "}
        <a href="/terms">Terms of Service</a>
      </p>
    </main>
  );
};

export default Support;
